// Reconstructed from production code; original paths and local names were not available.
import { AdminLayout } from "./layouts/AdminLayout.jsx";
import { AppLoading } from "./components/AppLoading.jsx";
import { CartPage } from "./pages/CartPage.jsx";
import { CategoryPage } from "./pages/CategoryPage.jsx";
import { CheckoutPage } from "./pages/CheckoutPage.jsx";
import { Footer } from "./components/Footer.jsx";
import { Header } from "./components/Header.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { Navigate } from "react-router-dom";
import { PartnersPage } from "./pages/PartnersPage.jsx";
import { ProductDetailPage } from "./pages/ProductDetailPage.jsx";
import { ProductsPage } from "./pages/ProductsPage.jsx";
import { ProtectedRoute } from "./routes/ProtectedRoute.jsx";
import React from "react";
import { Route } from "react-router-dom";
import { Routes } from "react-router-dom";
import { api } from "./services/api.js";
import * as jsxRuntime from "react/jsx-runtime";
import { useLanguage } from "./context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
const AdminLoginPage = React.lazy(
  () => import("./pages/admin/AdminLoginPage.jsx"),
);
const AdminDashboardPage = React.lazy(
  () => import("./pages/admin/AdminDashboardPage.jsx"),
);
const AdminProductsPage = React.lazy(
  () => import("./pages/admin/AdminProductsPage.jsx"),
);
const AdminCaissePage = React.lazy(
  () => import("./pages/admin/AdminCaissePage.jsx"),
);
const AdminCategoriesPage = React.lazy(
  () => import("./pages/admin/AdminCategoriesPage.jsx"),
);
const AdminAppearancePage = React.lazy(
  () => import("./pages/admin/AdminAppearancePage.jsx"),
);
const AdminPartnersPage = React.lazy(
  () => import("./pages/admin/AdminPartnersPage.jsx"),
);
const AdminFooterPage = React.lazy(
  () => import("./pages/admin/AdminFooterPage.jsx"),
);
const AdminCommandesPage = React.lazy(
  () => import("./pages/admin/AdminCommandesPage.jsx"),
);
const AdminClientsPage = React.lazy(
  () => import("./pages/admin/AdminClientsPage.jsx"),
);
const AdminUsersPage = React.lazy(
  () => import("./pages/admin/AdminUsersPage.jsx"),
);
const AdminPanierPage = React.lazy(
  () => import("./pages/admin/AdminPanierPage.jsx"),
);
const AdminVisitorsPage = React.lazy(
  () => import("./pages/admin/AdminVisitorsPage.jsx"),
);
function newVisitorId() {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function"
    ? crypto.randomUUID()
    : `v-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
function storedVisitorId(l, i) {
  try {
    const c = i.getItem(l);
    if (c) return c;
    const s = newVisitorId();
    i.setItem(l, s);
    return s;
  } catch {
    return newVisitorId();
  }
}
function RouteLoading() {
  const { language: language } = useLanguage(),
    i = language === "ar";
  return (
    <AppLoading
      variant={"route"}
      layout={"focus"}
      label={i ? "جارٍ تجهيز الصفحة…" : "Preparing the page…"}
      detail={
        i
          ? "لحظات قليلة وتكون جاهزة."
          : "Just a moment while everything gets ready."
      }
    />
  );
}
function App() {
  const l = useLocation(),
    i = l.pathname.startsWith("/admin");
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [l.pathname]);
  React.useEffect(() => {
    if (i || typeof window > "u") return;
    const c = l.pathname || "/",
      s = storedVisitorId("storefront_visitor_id", window.localStorage),
      d = storedVisitorId("storefront_visit_session_id", window.sessionStorage),
      f = `storefront_view:${d}:${c}`;
    if (window.sessionStorage.getItem(f)) return;
    window.sessionStorage.setItem(f, "1");
    const m = (() => {
      try {
        return document.referrer ? new URL(document.referrer).host : "";
      } catch {
        return "";
      }
    })();
    api
      .post("/visits/track", {
        visitor_id: s,
        session_id: d,
        path: c,
        locale: navigator.language,
        referrer_host: m,
      })
      .catch(() => {
        window.sessionStorage.removeItem(f);
      });
  }, [i, l.pathname]);
  return (
    <div className={"app-shell"}>
      {!i && <Header />}
      <main className={"container"}>
        <React.Suspense fallback={<RouteLoading />}>
          <Routes>
            <Route path={"/"} element={<HomePage />} />
            <Route path={"/products"} element={<ProductsPage />} />
            <Route path={"/products/:slug"} element={<ProductDetailPage />} />
            <Route path={"/category/:slug"} element={<CategoryPage />} />
            <Route path={"/partners"} element={<PartnersPage />} />
            <Route path={"/cart"} element={<CartPage />} />
            <Route path={"/checkout"} element={<CheckoutPage />} />
            <Route path={"/admin/login"} element={<AdminLoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path={"/admin"} element={<AdminLayout />}>
                <Route index={true} element={<AdminDashboardPage />} />
                <Route path={"dashboard"} element={<AdminDashboardPage />} />
                <Route path={"caisse"} element={<AdminCaissePage />} />
                <Route path={"products"} element={<AdminProductsPage />} />
                <Route path={"products/new"} element={<AdminProductsPage />} />
                <Route
                  path={"products/best-selling"}
                  element={<AdminProductsPage />}
                />
                <Route path={"categories"} element={<AdminCategoriesPage />} />
                <Route path={"appearance"} element={<AdminAppearancePage />} />
                <Route path={"partners"} element={<AdminPartnersPage />} />
                <Route path={"commandes"} element={<AdminCommandesPage />} />
                <Route path={"clients"} element={<AdminClientsPage />} />
                <Route path={"users"} element={<AdminUsersPage />} />
                <Route path={"paniers"} element={<AdminPanierPage />} />
                <Route path={"visitors"} element={<AdminVisitorsPage />} />
                <Route path={"footer"} element={<AdminFooterPage />} />
              </Route>
            </Route>
            <Route path={"*"} element={<Navigate to={"/"} replace={true} />} />
          </Routes>
        </React.Suspense>
      </main>
      {!i && <Footer />}
    </div>
  );
}
export {
  AdminLoginPage,
  AdminDashboardPage,
  AdminProductsPage,
  AdminCaissePage,
  AdminCategoriesPage,
  AdminAppearancePage,
  AdminPartnersPage,
  AdminFooterPage,
  AdminCommandesPage,
  AdminClientsPage,
  AdminUsersPage,
  AdminPanierPage,
  AdminVisitorsPage,
  newVisitorId,
  storedVisitorId,
  RouteLoading,
  App,
};
